(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orange-landing-recent-purchases"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(toast){
    if(!toast||toast.dataset.orangeToastReady==='true') return;
    toast.dataset.orangeToastReady='true';
    var entries=Array.from(toast.querySelectorAll('[data-orange-toast-entry]'));
    var title=toast.querySelector('[data-orange-toast-title]');
    var detail=toast.querySelector('[data-orange-toast-detail]');
    var avatar=toast.querySelector('[data-orange-toast-avatar]');
    var close=toast.querySelector('[data-orange-toast-close]');
    if(!entries.length||!title||!detail||!avatar) return;
    var middleEntries=entries.filter(function(entry){return entry.dataset.skuTier==='middle';});
    var highEntries=entries.filter(function(entry){return entry.dataset.skuTier==='high';});
    var lowEntries=entries.filter(function(entry){return entry.dataset.skuTier==='low';});
    var otherEntries=entries.filter(function(entry){return !['middle','high','low'].includes(entry.dataset.skuTier);});
    var regularEntries=middleEntries.concat(highEntries,otherEntries);
    if(!regularEntries.length) regularEntries=entries;
    var index=0;
    var regularIndex=0;
    var lowIndex=0;
    var timer;
    var dismissed=false;
    var stickyGap=14;
    var stickyResizeObservers=[];
    var followFrame=0;
    var followUntil=0;

    function followStickyAnimation(duration){
      followUntil=performance.now()+(duration||360);
      if(followFrame) return;
      function tick(now){
        syncToastOffset();
        if(now<followUntil){
          followFrame=requestAnimationFrame(tick);
        }else{
          followFrame=0;
          syncToastOffset();
        }
      }
      followFrame=requestAnimationFrame(tick);
    }

    function syncToastOffset(){
      var sticky=document.querySelector('.orange-sticky-cart:not([hidden])');
      var sheet=sticky&&sticky.querySelector('.orange-sticky-cart__sheet');
      if(!sheet){
        toast.style.removeProperty('bottom');
        return;
      }
      var rect=sheet.getBoundingClientRect();
      var lift=Math.max(0,window.innerHeight-rect.top)+stickyGap;
      toast.style.bottom=Math.round(lift)+'px';
    }

    function watchSticky(){
      var stickies=Array.from(document.querySelectorAll('.orange-sticky-cart'));
      var classObserver=new MutationObserver(function(){
        syncToastOffset();
        followStickyAnimation(380);
      });
      stickies.forEach(function(sticky){
        classObserver.observe(sticky,{attributes:true,attributeFilter:['class','hidden']});
        var sheet=sticky.querySelector('.orange-sticky-cart__sheet');
        if(sheet&&'ResizeObserver' in window){
          var ro=new ResizeObserver(function(){syncToastOffset();});
          ro.observe(sheet);
          stickyResizeObservers.push(ro);
        }
      });
      window.addEventListener('resize',syncToastOffset,{passive:true});
      window.addEventListener('orange:sticky-viewport-change',syncToastOffset);
      syncToastOffset();
    }
    watchSticky();
    // ORANGE TOAST STICKY FOLLOW V1
    // ORANGE TOAST FAST FOLLOW V2
    function busy(){return !!document.querySelector('cart-drawer.active');}
    function next(){
      if(dismissed) return;
      if(busy()){timer=window.setTimeout(next,1500);return;}
      var entry;
      if(index===0){
        entry=middleEntries[0]||regularEntries[0];
      }else if(lowEntries.length&&index%7===6){
        entry=lowEntries[lowIndex%lowEntries.length];
        lowIndex+=1;
      }else{
        entry=regularEntries[regularIndex%regularEntries.length];
        regularIndex+=1;
      }
      index+=1;
      title.textContent=toast.dataset.orangeOrderedLabel+' · '+entry.dataset.amount;
      detail.textContent=entry.dataset.age+' · '+entry.dataset.state;
      var image=document.createElement('img');
      if(entry.dataset.avatar){
        image.src=entry.dataset.avatar;
        image.alt='';
        avatar.replaceChildren(image);
      }else{
        avatar.replaceChildren();
      }
      syncToastOffset();
      toast.hidden=false;
      requestAnimationFrame(function(){syncToastOffset();toast.classList.add('is-visible');});
      timer=window.setTimeout(function(){
        toast.classList.remove('is-visible');
        timer=window.setTimeout(next,2400);
      },4600);
    }
    close.addEventListener('click',function(){
      dismissed=true;
      window.clearTimeout(timer);
      toast.classList.remove('is-visible');
      window.setTimeout(function(){toast.hidden=true;},250);
    });
    timer=window.setTimeout(next,30000);
  }
  function boot(root){(root||document).querySelectorAll('[data-orange-purchase-toast]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orange-landing-sticky-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBar(bar){
    if(!bar||bar.dataset.orangeLandingStickyReady==='true') return;

    var bundle=document.querySelector('#orange-offer-bundle');
    if(!bundle) return;

    var mainButton=bundle.querySelector('[data-dc-add-to-cart]');
    var mainInputs=[].slice.call(bundle.querySelectorAll('[data-dc-variant-radio]'));
    var mainQtyMinus=bundle.querySelector('[data-dc-qty-minus]');
    var mainQtyPlus=bundle.querySelector('[data-dc-qty-plus]');
    var mainQtyValue=bundle.querySelector('[data-dc-qty-value]');

    function buildStickyBundleFromMain(){
      var pickerMount=bar.querySelector('[data-orange-sticky-picker-mount]');
      if(!pickerMount||pickerMount.firstElementChild) return;
      // The title-area SKU alone owns all card markup and product content.
      var clone=bundle.cloneNode(true);
      var clonedOptions=clone.querySelector(':scope > .dc-lp-bundle__options');
      if(!clonedOptions) return;
      clone.removeAttribute('id');
      clone.removeAttribute('data-dc-bundle');
      clone.classList.add('orange-sticky-cart__bundle');
      [].slice.call(clone.children).forEach(function(child){
        if(!child.classList.contains('dc-lp-bundle__heading')&&!child.classList.contains('dc-lp-bundle__options')) child.remove();
      });
      // Reinitialize the shared adaptive-height controller on the fresh SKU clone.
      clonedOptions.classList.remove('dc-sku-ui-ready');
      clonedOptions.style.removeProperty('--dc-sku-first-closed-height');
      var stickyName='orange-landing-sticky-choice-'+bar.dataset.productId;

      [].slice.call(clonedOptions.querySelectorAll('[data-dc-bundle-option]')).forEach(function(card,index){
        card.setAttribute('data-orange-sticky-card','');
        card.removeAttribute('data-dc-bundle-option');
        card.removeAttribute('data-dc-sku-first-observed');
        card.classList.remove('is-benefits-open');

        var input=card.querySelector('[data-dc-variant-radio]');
        if(input){
          input.setAttribute('data-orange-sticky-choice','');
          input.removeAttribute('data-dc-variant-radio');
          input.name=stickyName;

          var newId='OrangeLandingStickyVariant-'+bar.dataset.productId+'-'+(index+1);
          input.id=newId;
          var label=card.querySelector('label[for]');
          if(label) label.setAttribute('for',newId);

          var title=card.querySelector('.dc-lp-bundle-option__title');
          var current=card.querySelector('.dc-lp-bundle-option__price strong');
          var compare=card.querySelector('.dc-lp-bundle-option__was s');
          input.dataset.title=title&&title.textContent?title.textContent.trim():'';
          input.dataset.detail='';
          input.dataset.price=current&&current.textContent?current.textContent.trim():'';
          input.dataset.compare=compare&&compare.textContent?compare.textContent.trim():'';
        }

        var panel=card.querySelector('[data-dc-service-panel]');
        if(panel){
          panel.setAttribute('data-orange-sticky-service-panel','');
          panel.removeAttribute('data-dc-service-panel');
          panel.setAttribute('aria-hidden','true');
          panel.classList.remove('dc-sku-motion-panel');
          panel.style.removeProperty('height');
          panel.style.removeProperty('transition');
          panel.inert=false;
        }
        card.querySelectorAll('[data-dc-service-toggle]').forEach(function(toggle){
          toggle.removeAttribute('data-dc-service-toggle');
        });
      });

      pickerMount.appendChild(clone);
    }

    buildStickyBundleFromMain();

    var stickyButton=bar.querySelector('[data-orange-sticky-submit]');
    var stickyLabel=bar.querySelector('[data-orange-sticky-label]');
    var stickyTitle=bar.querySelector('[data-orange-sticky-title]');
    var stickyVariant=bar.querySelector('[data-orange-sticky-variant]');
    var stickyPrice=bar.querySelector('[data-orange-sticky-price]');
    var stickyCompare=bar.querySelector('[data-orange-sticky-compare]');
    var stickyInputs=[].slice.call(bar.querySelectorAll('[data-orange-sticky-choice]'));
    var stickyCards=[].slice.call(bar.querySelectorAll('[data-orange-sticky-card]'));
    var stickyQtyMinus=bar.querySelector('[data-orange-sticky-qty-minus]');
    var stickyQtyPlus=bar.querySelector('[data-orange-sticky-qty-plus]');
    var stickyQtyValue=bar.querySelector('[data-orange-sticky-qty-value]');
    var pickerSubmit=bar.querySelector('[data-orange-sticky-picker-submit]');
    var sheet=bar.querySelector('[data-orange-sticky-sheet]');
    var picker=bar.querySelector('[data-orange-sticky-picker]');
    var stickyInner=bar.querySelector('.orange-sticky-cart__inner');
    var closeButton=bar.querySelector('[data-orange-sticky-close]');
    var mobile=window.matchMedia('(max-width:749px)');

    var lastScrollY=window.scrollY;
    var direction='none';
    var scrollFrame=0;
    var benefitsVariantId='';
    var editorScrollY=window.scrollY;
    var sectionRoot=bar.closest('.shopify-section');
    var sectionRootId=sectionRoot&&sectionRoot.id?sectionRoot.id:'';
    var sectionToken=sectionRootId.replace(/^shopify-section-/,'');

    // Same collapsed-bar viewport clearance as the Orange product template.
    var mainContent=document.getElementById('MainContent');
    function reserveCollapsedRoom(){
      if(!mainContent||!sheet||bar.classList.contains('is-open')) return;
      var collapsedHeight=Math.ceil(sheet.getBoundingClientRect().height);
      if(collapsedHeight>0){
        mainContent.style.setProperty('--orange-sticky-collapsed-room',(collapsedHeight+12)+'px');
      }
    }
    if(window.ResizeObserver&&sheet){
      new ResizeObserver(reserveCollapsedRoom).observe(sheet);
    }

    function isThemeEditor(){
      return !!(window.Shopify&&window.Shopify.designMode);
    }

    function captureEditorScroll(){
      if(isThemeEditor()) editorScrollY=window.scrollY;
    }

    function restoreEditorScroll(){
      if(!isThemeEditor()) return;
      [0,16,50,120,250,500,900].forEach(function(delay){
        window.setTimeout(function(){
          if(Math.abs(window.scrollY-editorScrollY)>1){
            window.scrollTo({top:editorScrollY,left:0,behavior:'auto'});
          }
        },delay);
      });
    }

    bar.addEventListener('pointerdown',function(){
      if(!mobile.matches) return;
      captureEditorScroll();
      restoreEditorScroll();
    },true);

    if(!window.__orangeLandingStickySectionSelectGuard){
      window.__orangeLandingStickySectionSelectGuard={};
    }
    var sectionGuardKey=sectionRootId||bar.dataset.productId||'landing-sticky';
    if(!window.__orangeLandingStickySectionSelectGuard[sectionGuardKey]){
      document.addEventListener('shopify:section:select',function(event){
        if(!isThemeEditor()) return;
        var eventId=event.detail&&event.detail.sectionId;
        var targetId=event.target&&event.target.id;
        if((sectionToken&&eventId===sectionToken)||(sectionRootId&&targetId===sectionRootId)){
          restoreEditorScroll();
        }
      });
      window.__orangeLandingStickySectionSelectGuard[sectionGuardKey]=true;
    }

    function selectedMain(){
      return mainInputs.find(function(input){return input.checked});
    }

    function selectedSticky(){
      var main=selectedMain();
      if(!main) return null;
      return stickyInputs.find(function(input){return input.value===main.value})||null;
    }

    function passedMainBundle(){
      return bundle.getBoundingClientRect().bottom<0;
    }

    // ORANGE LANDING STICKY IOS BOTTOM BOUNCE FIX V1
    function distanceFromPageBottom(){
      var doc=document.documentElement;
      var body=document.body;
      var pageHeight=Math.max(
        doc?doc.scrollHeight:0,
        body?body.scrollHeight:0
      );
      var viewportHeight=Math.max(
        window.innerHeight||0,
        window.visualViewport?window.visualViewport.height:0
      );
      return pageHeight-(Math.max(0,window.scrollY)+viewportHeight);
    }

    function atPageBottom(){
      return distanceFromPageBottom()<=140;
    }

    function shouldShowSticky(){
      return passedMainBundle()&&(direction==='down'||(mobile.matches&&atPageBottom()));
    }

    function sync(){
      var main=selectedMain();
      if(!main) return;

      stickyInputs.forEach(function(input){
        var checked=input.value===main.value;
        input.checked=checked;
        var card=input.closest('[data-orange-sticky-card]');
        if(card){
          var benefitsOpen=checked&&input.value===benefitsVariantId;
          card.classList.toggle('is-selected',checked);
          card.classList.toggle('is-benefits-open',benefitsOpen);
          var panel=card.querySelector('[data-orange-sticky-service-panel]');
          if(panel) panel.setAttribute('aria-hidden',benefitsOpen?'false':'true');
        }
      });

      var data=selectedSticky();
      if(data){
        if(stickyTitle){
          stickyTitle.textContent=data.dataset.title||data.dataset.detail||'';
        }
        if(stickyVariant){
          stickyVariant.textContent=data.dataset.detail||'';
        }
        if(stickyPrice) stickyPrice.textContent=data.dataset.price||'';

        if(stickyCompare){
          if(data.dataset.compare){
            stickyCompare.textContent=data.dataset.compare;
            stickyCompare.hidden=false;
          }else{
            stickyCompare.textContent='';
            stickyCompare.hidden=true;
          }
        }
      }

      if(stickyQtyValue&&mainQtyValue){
        stickyQtyValue.textContent=mainQtyValue.textContent.trim()||'1';
      }

      if(stickyLabel&&mainButton){
        var mainLabel=mainButton.textContent.trim();
        if(mainLabel) stickyLabel.textContent=mainLabel;
      }

      if(mainButton){
        var mainButtonStyle=window.getComputedStyle(mainButton);
        bar.style.setProperty('--orange-sticky-cta-bg',mainButtonStyle.backgroundColor||'var(--orange-theme-primary)');
        bar.style.setProperty('--orange-sticky-cta-color',mainButtonStyle.color||'var(--orange-theme-on-primary)');
        bar.style.setProperty('--orange-sticky-cta-border',mainButtonStyle.borderTopColor||mainButtonStyle.backgroundColor||'var(--orange-theme-primary)');
      }

      var disabled=main.disabled||Boolean(mainButton&&mainButton.disabled);
      if(stickyButton) stickyButton.disabled=disabled;
      if(pickerSubmit){
        var busy=Boolean(mainButton&&mainButton.getAttribute('aria-busy')==='true');
        if(mainButton) pickerSubmit.textContent=mainButton.textContent.trim();
        pickerSubmit.setAttribute('aria-busy',busy?'true':'false');
        pickerSubmit.disabled=disabled;
      }
    }

    function checkoutInProgress(){
      return Boolean(mainButton&&mainButton.getAttribute('aria-busy')==='true');
    }

    function setOpen(open){
      // Main BUY NOW owns the checkout state. Never collapse after its redirect starts.
      if(!open&&checkoutInProgress()) return;
      if(!bundle) open=false;

      benefitsVariantId='';
      bar.classList.toggle('is-open',open);
      if(stickyButton) stickyButton.setAttribute('aria-expanded',open?'true':'false');
      if(picker) picker.setAttribute('aria-hidden',open?'false':'true');
      if(open) bar.hidden=false;
      sync();
    }

    function closeAndRespectDirection(){
      if(checkoutInProgress()) return;
      setOpen(false);
      bar.hidden=!shouldShowSticky();
    }

    function updateVisibilityByDirection(){
      var currentY=Math.max(0,window.scrollY);

      if(checkoutInProgress()){
        lastScrollY=currentY;
        return;
      }
      if(bar.classList.contains('is-open')){
        lastScrollY=currentY;
        return;
      }

      if(mobile.matches&&passedMainBundle()&&atPageBottom()){
        direction='down';
        lastScrollY=currentY;
        bar.hidden=false;
        return;
      }

      var delta=currentY-lastScrollY;

      if(delta>3){
        direction='down';
        lastScrollY=currentY;
        bar.hidden=!passedMainBundle();
        return;
      }

      if(delta<-3){
        direction='up';
        lastScrollY=currentY;
        bar.hidden=true;
      }
    }

    stickyInputs.forEach(function(input){
      input.addEventListener('change',function(event){
        event.preventDefault();
        event.stopPropagation();

        var target=mainInputs.find(function(mainInput){
          return mainInput.value===input.value;
        });
        if(!target||target.disabled) return;

        benefitsVariantId=input.value;
        target.dataset.dcStickySync='true';
        target.checked=true;
        target.dispatchEvent(new Event('change',{bubbles:true}));
        delete target.dataset.dcStickySync;
        sync();

        window.setTimeout(function(){
          sync();
        },40);
      });
    });

    stickyCards.forEach(function(card){
      card.addEventListener('click',function(event){
        if(event.target.closest('.dc-lp-service-row')) return;
        if(event.target.matches&&event.target.matches('[data-orange-sticky-choice]')) return;
        var input=card.querySelector('[data-orange-sticky-choice]');
        if(!input||input.disabled) return;

        event.preventDefault();
        event.stopPropagation();

        var wasOpen=input.checked&&benefitsVariantId===input.value;
        benefitsVariantId=wasOpen?'':input.value;

        if(!input.checked){
          input.checked=true;
          input.dispatchEvent(new Event('change',{bubbles:true}));
          return;
        }

        sync();
      });
    });
    // ORANGE LANDING STICKY SKU BENEFIT TOGGLE V1
    // ORANGE LANDING STICKY SCROLL STABILITY V1
    // ORANGE LANDING STICKY EDITOR JUMP FIX V1
    // ORANGE LANDING STICKY EDITOR JUMP FIX V2

    if(stickyQtyMinus){
      stickyQtyMinus.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        if(mainQtyMinus) mainQtyMinus.click();
        window.setTimeout(sync,20);
      });
    }

    if(stickyQtyPlus){
      stickyQtyPlus.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        if(mainQtyPlus) mainQtyPlus.click();
        window.setTimeout(sync,20);
      });
    }

    if(pickerSubmit){
      // ORANGE LANDING CHECKOUT KEEP PICKER OPEN V1
      pickerSubmit.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        var main=selectedMain();
        if(!main||main.disabled||!mainButton) return;

        // Keep the SKU sheet visible while checkout navigation starts.
        // The main BUY NOW handler owns the direct checkout redirect and click lock.
        bar.hidden=false;
        mainButton.click();
      });
    }

    if(stickyButton){
      // ORANGE LANDING STICKY DIRECT ADD V1
      stickyButton.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();

        var main=selectedMain();
        if(!main||main.disabled||!mainButton) return;

        // Preserve the collapsed bar instead of replaying its close animation.
        mainButton.click();
      });
    }

    if(stickyInner){
      stickyInner.addEventListener('click',function(event){
        if(event.target.closest('[data-orange-sticky-submit]')) return;
        if(bar.classList.contains('is-open')) return;

        event.preventDefault();
        event.stopPropagation();

        captureEditorScroll();
        setOpen(true);
        restoreEditorScroll();
      });
    }

    if(closeButton){
      closeButton.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        direction='up';
        lastScrollY=Math.max(0,window.scrollY);
        bar.hidden=true;
      });
    }

    window.OrangeStickySwipe.bind(bar,closeAndRespectDirection);

    document.addEventListener('pointerdown',function(event){
      if(!bar.classList.contains('is-open')) return;
      if(sheet&&sheet.contains(event.target)) return;
      if(event.target.closest&&event.target.closest('[data-dc-add-to-cart]')) return;
      closeAndRespectDirection();
    },true);

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&bar.classList.contains('is-open')){
        closeAndRespectDirection();
        if(stickyButton) stickyButton.focus({preventScroll:true});
      }
    });

    bundle.addEventListener('change',function(){
      window.setTimeout(sync,20);
    });

    var observer=new MutationObserver(function(){
      sync();
    });
    observer.observe(bundle,{
      subtree:true,
      attributes:true,
      childList:true,
      characterData:true,
      attributeFilter:['checked','class','disabled']
    });

    window.addEventListener('scroll',function(){
      if(scrollFrame) return;
      scrollFrame=requestAnimationFrame(function(){
        scrollFrame=0;
        updateVisibilityByDirection();
        reserveCollapsedRoom();
      });
    },{passive:true});

    window.addEventListener('resize',function(){
      if(checkoutInProgress()) return;
      setOpen(false);
      bar.hidden=!shouldShowSticky();
      reserveCollapsedRoom();
    },{passive:true});

    if(window.visualViewport){
      window.visualViewport.addEventListener('resize',function(){
        if(checkoutInProgress()||bar.classList.contains('is-open')) return;
        bar.hidden=!shouldShowSticky();
      },{passive:true});
    }

    mobile.addEventListener('change',function(){
      if(checkoutInProgress()) return;
      setOpen(false);
      bar.hidden=!shouldShowSticky();
    });

    // ORANGE CART DRAWER CHECKOUT CLICK GUARD V1
    var cartDrawer=document.querySelector('cart-drawer');
    if(cartDrawer){
      function syncWithCartDrawer(){
        if(checkoutInProgress()) return;
        var drawerOpen=cartDrawer.classList.contains('active');
        if(drawerOpen){
          if(bar.classList.contains('is-open')) setOpen(false);
          bar.hidden=true;
          bar.style.pointerEvents='none';
          return;
        }
        bar.style.removeProperty('pointer-events');
        bar.hidden=!shouldShowSticky();
      }
      var cartObserver=new MutationObserver(syncWithCartDrawer);
      cartObserver.observe(cartDrawer,{attributes:true,attributeFilter:['class']});
      syncWithCartDrawer();
    }

    sync();
    bar.hidden=true;
    reserveCollapsedRoom();
    bar.dataset.orangeLandingStickyReady='true';
  }

  function init(root){
    (root||document).querySelectorAll('[data-orange-landing-sticky]').forEach(initBar);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){init(document)},{once:true});
  }else{
    init(document);
  }

  document.addEventListener('shopify:section:load',function(event){
    init(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orange-recent-purchases"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(toast){
    if(!toast||toast.dataset.orangeToastReady==='true') return;
    toast.dataset.orangeToastReady='true';
    var entries=Array.from(toast.querySelectorAll('[data-orange-toast-entry]'));
    var title=toast.querySelector('[data-orange-toast-title]');
    var detail=toast.querySelector('[data-orange-toast-detail]');
    var avatar=toast.querySelector('[data-orange-toast-avatar]');
    var close=toast.querySelector('[data-orange-toast-close]');
    if(!entries.length||!title||!detail||!avatar) return;
    var middleEntries=entries.filter(function(entry){return entry.dataset.skuTier==='middle';});
    var highEntries=entries.filter(function(entry){return entry.dataset.skuTier==='high';});
    var lowEntries=entries.filter(function(entry){return entry.dataset.skuTier==='low';});
    var otherEntries=entries.filter(function(entry){return !['middle','high','low'].includes(entry.dataset.skuTier);});
    var regularEntries=middleEntries.concat(highEntries,otherEntries);
    if(!regularEntries.length) regularEntries=entries;
    var index=0;
    var regularIndex=0;
    var lowIndex=0;
    var timer;
    var dismissed=false;
    var stickyGap=14;
    var stickyResizeObservers=[];
    var followFrame=0;
    var followUntil=0;

    function followStickyAnimation(duration){
      followUntil=performance.now()+(duration||360);
      if(followFrame) return;
      function tick(now){
        syncToastOffset();
        if(now<followUntil){
          followFrame=requestAnimationFrame(tick);
        }else{
          followFrame=0;
          syncToastOffset();
        }
      }
      followFrame=requestAnimationFrame(tick);
    }

    function syncToastOffset(){
      var sticky=document.querySelector('.orange-sticky-cart:not([hidden])');
      var sheet=sticky&&sticky.querySelector('.orange-sticky-cart__sheet');
      if(!sheet){
        toast.style.removeProperty('bottom');
        return;
      }
      var rect=sheet.getBoundingClientRect();
      var lift=Math.max(0,window.innerHeight-rect.top)+stickyGap;
      toast.style.bottom=Math.round(lift)+'px';
    }

    function watchSticky(){
      var stickies=Array.from(document.querySelectorAll('.orange-sticky-cart'));
      var classObserver=new MutationObserver(function(){
        syncToastOffset();
        followStickyAnimation(380);
      });
      stickies.forEach(function(sticky){
        classObserver.observe(sticky,{attributes:true,attributeFilter:['class','hidden']});
        var sheet=sticky.querySelector('.orange-sticky-cart__sheet');
        if(sheet&&'ResizeObserver' in window){
          var ro=new ResizeObserver(function(){syncToastOffset();});
          ro.observe(sheet);
          stickyResizeObservers.push(ro);
        }
      });
      window.addEventListener('resize',syncToastOffset,{passive:true});
      window.addEventListener('orange:sticky-viewport-change',syncToastOffset);
      syncToastOffset();
    }
    watchSticky();
    // ORANGE TOAST STICKY FOLLOW V1
    // ORANGE TOAST FAST FOLLOW V2
    function busy(){return !!document.querySelector('cart-drawer.active');}
    function next(){
      if(dismissed) return;
      if(busy()){timer=window.setTimeout(next,1500);return;}
      var entry;
      if(index===0){
        entry=middleEntries[0]||regularEntries[0];
      }else if(lowEntries.length&&index%7===6){
        entry=lowEntries[lowIndex%lowEntries.length];
        lowIndex+=1;
      }else{
        entry=regularEntries[regularIndex%regularEntries.length];
        regularIndex+=1;
      }
      index+=1;
      title.textContent=toast.dataset.orangeOrderedLabel+' · '+entry.dataset.amount;
      detail.textContent=entry.dataset.age+' · '+entry.dataset.state;
      var image=document.createElement('img');
      if(entry.dataset.avatar){
        image.src=entry.dataset.avatar;
        image.alt='';
        avatar.replaceChildren(image);
      }else{
        avatar.replaceChildren();
      }
      syncToastOffset();
      toast.hidden=false;
      requestAnimationFrame(function(){syncToastOffset();toast.classList.add('is-visible');});
      timer=window.setTimeout(function(){
        toast.classList.remove('is-visible');
        timer=window.setTimeout(next,2400);
      },4600);
    }
    close.addEventListener('click',function(){
      dismissed=true;
      window.clearTimeout(timer);
      toast.classList.remove('is-visible');
      window.setTimeout(function(){toast.hidden=true;},250);
    });
    timer=window.setTimeout(next,30000);
  }
  function boot(root){(root||document).querySelectorAll('[data-orange-purchase-toast]').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orange-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  function plainText(value){
    if(!value) return '';
    var box=document.createElement('div');
    box.innerHTML=String(value);
    return (box.textContent||box.innerText||'').replace(/\s+/g,' ').trim();
  }

  function judgeData(productId){
    var widgets=window.jdgm&&window.jdgm.data&&window.jdgm.data.reviewWidget;
    if(!widgets) return null;
    return widgets[productId]||widgets[String(productId)]||null;
  }

  function normalize(data){
    if(!data) return [];
    var pageReviews=Array.isArray(data.reviews)?data.reviews:[];
    var gallery=Array.isArray(data.photo_gallery)?data.photo_gallery:[];
    var pageById={};
    pageReviews.forEach(function(review){
      if(review&&review.uuid) pageById[review.uuid]=review;
    });
    var source=gallery.length?gallery:pageReviews;

    return source.map(function(review){
      if(!review) return null;
      var page=review.uuid?pageById[review.uuid]:null;
      var pictures=Array.isArray(review.pictures_urls)?review.pictures_urls:[];
      var picture=pictures[0]||{};
      var title=plainText(review.title||(page&&page.title));
      var body=plainText(review.body_html||review.body||(page&&page.body_html)||(page&&page.body));
      var rating=Math.max(0,Math.min(5,Math.round(Number(review.rating||(page&&page.rating))||0)));
      return {
        author:plainText(review.reviewer_name||(page&&page.reviewer_name)),
        title:title,
        body:body,
        rating:rating,
        avatar:(page&&page.avatar_image_url)||review.avatar_image_url||'',
        verified:Boolean(review.verified_buyer||(page&&page.verified_buyer)||review.verified||(page&&page.verified)),
        media:picture.huge||picture.original||picture.compact||picture.small||'',
        mediaAlt:title||plainText(review.reviewer_name||(page&&page.reviewer_name))
      };
    }).filter(function(review){return review&&(review.title||review.body);});
  }

  function card(data,verifiedLabel){
    var article=document.createElement('article');
    article.className='orange-judge-review-card';

    if(data.media){
      var mediaWrap=document.createElement('div');
      mediaWrap.className='orange-judge-review-card__media-wrap';

      var image=document.createElement('img');
      image.className='orange-judge-review-card__media';
      image.loading='lazy';
      image.src=data.media;
      image.alt=data.mediaAlt;
      mediaWrap.appendChild(image);

      article.appendChild(mediaWrap);
    }

    var content=document.createElement('div');
    content.className='orange-judge-review-card__content';

    var stars=document.createElement('div');
    stars.className='orange-judge-review-card__stars';
    if(data.rating>0){
      stars.textContent='★'.repeat(data.rating)+'☆'.repeat(5-data.rating);
      stars.setAttribute('aria-label',data.rating+'/5');
    }
    content.appendChild(stars);

    if(data.title){
      var title=document.createElement('h3');
      title.className='orange-judge-review-card__title';
      title.textContent=data.title;
      content.appendChild(title);
    }

    if(data.body){
      var copy=document.createElement('p');
      copy.className='orange-judge-review-card__copy';
      copy.textContent=data.body;
      content.appendChild(copy);
    }

    if(data.author){
      var author=document.createElement('div');
      author.className='orange-judge-review-card__author';
      var name=document.createElement('strong');
      name.className='orange-judge-review-card__name';
      name.textContent=data.author;
      author.appendChild(name);
      if(data.verified){
        var verified=document.createElement('span');
        verified.className='orange-judge-review-card__verified';
        var check=document.createElement('b');
        check.textContent='✓';
        check.setAttribute('aria-hidden','true');
        verified.appendChild(check);
        verified.appendChild(document.createTextNode(verifiedLabel||''));
        author.appendChild(verified);
      }
      content.appendChild(author);
    }

    article.appendChild(content);
    return article;
  }

  function hydrateProof(reviews){
    var proof=document.querySelector('[data-orange-proof]');
    if(!proof) return;
    var wrapper=proof.querySelector('[data-orange-proof-avatars]');
    var slots=[].slice.call(proof.querySelectorAll('[data-orange-proof-avatar]'));
    var sourceReviews=reviews.filter(function(review){return review&&(review.author||review.avatar);});

    function fallbackMark(name){
      var value=plainText(name);
      return value?value.charAt(0).toUpperCase():'•';
    }

    slots.forEach(function(slot,i){
      if(slot.dataset.manualAvatar==='true'){
        slot.hidden=false;
        return;
      }

      var data=sourceReviews.length?sourceReviews[i%sourceReviews.length]:null;
      slot.hidden=false;
      slot.innerHTML='';

      if(data&&data.avatar){
        var img=document.createElement('img');
        img.src=data.avatar;
        img.alt='';
        img.loading='lazy';
        slot.appendChild(img);
      }else{
        var fallback=document.createElement('span');
        fallback.className='orange-proof__avatar-fallback orange-proof__avatar-fallback--initial';
        fallback.setAttribute('aria-hidden','true');
        fallback.textContent=fallbackMark(data&&data.author);
        slot.appendChild(fallback);
      }

      if(data&&data.verified){
        var check=document.createElement('span');
        check.className='orange-proof__verified';
        check.setAttribute('aria-hidden','true');
        check.textContent='✓';
        slot.appendChild(check);
      }
    });

    if(wrapper) wrapper.classList.remove('is-empty');
    proof.classList.remove('is-empty');
  }

  function mount(box,reviews){
    if(box.dataset.orangeJudgeReady==='true'||!reviews.length) return;
    var track=box.querySelector('[data-orange-judge-track]');
    var dots=box.querySelector('[data-orange-judge-dots]');
    var prev=box.querySelector('[data-orange-judge-prev]');
    var next=box.querySelector('[data-orange-judge-next]');
    if(!track||!dots) return;

    var verifiedLabel=box.dataset.verifiedLabel||'';
    reviews.slice(0,10).forEach(function(review){track.appendChild(card(review,verifiedLabel));});
    var cards=[].slice.call(track.children);
    var label=box.dataset.dotLabel||'';

    cards.forEach(function(_,i){
      var dot=document.createElement('button');
      dot.type='button';
      dot.className='orange-judge-reviews__dot'+(i===0?' is-active':'');
      dot.setAttribute('aria-label',(label?label+' ':'')+(i+1));
      dot.addEventListener('click',function(){
        track.scrollTo({left:cards[i].offsetLeft-track.offsetLeft,behavior:'smooth'});
      });
      dots.appendChild(dot);
    });

    function maxScroll(){return Math.max(0,track.scrollWidth-track.clientWidth);}
    function activeIndex(){
      var target=track.scrollLeft;
      var best=Infinity;
      var index=0;
      cards.forEach(function(item,i){
        var distance=Math.abs((item.offsetLeft-track.offsetLeft)-target);
        if(distance<best){best=distance;index=i;}
      });
      return index;
    }
    function update(){
      var index=activeIndex();
      [].slice.call(dots.children).forEach(function(dot,i){
        dot.classList.toggle('is-active',i===index);
        dot.setAttribute('aria-current',i===index?'true':'false');
      });
      if(prev) prev.disabled=track.scrollLeft<=2;
      if(next) next.disabled=track.scrollLeft>=maxScroll()-2;
    }

    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-track.clientWidth,behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:track.clientWidth,behavior:'smooth'});});

    var ticking=false;
    track.addEventListener('scroll',function(){
      if(ticking) return;
      ticking=true;
      requestAnimationFrame(function(){update();ticking=false;});
    },{passive:true});

    box.hidden=false;
    box.dataset.orangeJudgeReady='true';
    hydrateProof(reviews);
    update();
  }

  function initBox(box){
    if(!box||box.dataset.orangeJudgeReady==='true') return;
    var attempts=0;
    var timer=window.setInterval(function(){
      attempts+=1;
      var reviews=normalize(judgeData(box.dataset.productId));
      if(reviews.length){
        window.clearInterval(timer);
        mount(box,reviews);
      }else if(attempts>=50){
        window.clearInterval(timer);
      }
    },200);
  }

  function init(root){
    (root||document).querySelectorAll('[data-orange-judge-reviews]').forEach(initBox);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});
  }else{
    init(document);
  }

  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orange-sticky-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initBar(bar){
    if(!bar||bar.dataset.orangeStickyReady==='true') return;
    var main=document.querySelector('product-info[data-product-id="'+bar.dataset.productId+'"]');
    if(!main) return;

    var stickyButton=bar.querySelector('[data-orange-sticky-submit]');
    var stickyLabel=bar.querySelector('[data-orange-sticky-label]');
    var stickyTitle=bar.querySelector('[data-orange-sticky-title]');
    var stickyPrice=bar.querySelector('[data-orange-sticky-price]');
    var stickyCompare=bar.querySelector('[data-orange-sticky-compare]');
    var stickyVariant=bar.querySelector('[data-orange-sticky-variant]');
    var picker=bar.querySelector('[data-orange-sticky-picker]');
    var pickerMount=bar.querySelector('[data-orange-sticky-picker-mount]');
    var sheet=bar.querySelector('.orange-sticky-cart__sheet');
    var stickyInner=bar.querySelector('.orange-sticky-cart__inner');
    var closeButton=bar.querySelector('[data-orange-sticky-close]');
    var actionSubmit=bar.querySelector('[data-orange-sticky-action-submit]');
    var actionQtyMinus=bar.querySelector('[data-orange-sticky-qty-minus]');
    var actionQtyPlus=bar.querySelector('[data-orange-sticky-qty-plus]');
    var actionQtyValue=bar.querySelector('[data-orange-sticky-qty-value]');
    var actionQty=1;
    var mobile=window.matchMedia('(max-width:749px)');
    var mainBundle=main.querySelector('[data-orange-bundle]');
    var lastScrollY=Math.max(0,window.scrollY);
    var direction='none';

    function mainButton(){return main.querySelector('.product-form__submit')}

    function renderActionQty(){
      if(actionQtyValue) actionQtyValue.textContent=String(actionQty);
    }

    function applyActionQuantity(){
      var form=main.querySelector('form[id^="product-form-"]');
      if(!form) return;
      var qtyInput=form.querySelector('input[name="quantity"]');
      if(!qtyInput&&form.id){
        qtyInput=document.querySelector('input[name="quantity"][form="'+form.id+'"]');
      }
      if(!qtyInput){
        qtyInput=document.createElement('input');
        qtyInput.type='hidden';
        qtyInput.name='quantity';
        qtyInput.setAttribute('data-orange-sticky-order-quantity','');
        form.appendChild(qtyInput);
      }
      var multiplier=1;
      if(mainBundle&&mainBundle.dataset.mode==='quantity'){
        var setupChoice=mainBundle.querySelector('input[type="radio"]:checked');
        multiplier=Math.max(1,parseInt(setupChoice&&setupChoice.value,10)||1);
      }
      qtyInput.value=String(Math.max(1,multiplier*actionQty));
      qtyInput.dispatchEvent(new Event('change',{bubbles:true}));
    }

    function selectedPack(){
      return main.querySelector('[data-orange-bundle] .orange-pack.is-selected');
    }

    function buildPicker(){
      if(!mainBundle||!pickerMount||pickerMount.firstElementChild) return;
      var clone=mainBundle.cloneNode(true);
      clone.removeAttribute('data-orange-bundle');
      clone.removeAttribute('data-form-id');
      clone.removeAttribute('data-section-id');
      [].slice.call(clone.attributes).forEach(function(attribute){
        if(attribute.name.indexOf('data-shopify-editor-')===0) clone.removeAttribute(attribute.name);
      });
      clone.querySelectorAll('input[type="hidden"]').forEach(function(input){input.remove()});
      clone.querySelectorAll('.orange-pack').forEach(function(card){card.classList.remove('is-benefits-open')});
      clone.querySelectorAll('input[type="radio"]').forEach(function(input){
        input.name='orange-sticky-choice-'+bar.dataset.productId;
        input.removeAttribute('form');
      });
      pickerMount.appendChild(clone);
    }

    function syncPicker(){
      if(!mainBundle||!pickerMount) return;
      var mainInputs=[].slice.call(mainBundle.querySelectorAll('input[type="radio"]'));
      var selected=mainInputs.find(function(input){return input.checked});
      var stickyInputs=[].slice.call(pickerMount.querySelectorAll('input[type="radio"]'));
      stickyInputs.forEach(function(input){
        var source=mainInputs.find(function(mainInput){return mainInput.value===input.value});
        input.checked=Boolean(selected&&input.value===selected.value);
        input.disabled=Boolean(source&&source.disabled);
        var card=input.closest('.orange-pack');
        if(card){
          card.classList.toggle('is-selected',input.checked);
          if(!input.checked) card.classList.remove('is-benefits-open');
        }
      });
    }

    function sync(){
      var button=mainButton();
      if(!button) return;
      var selectedInput=mainBundle&&mainBundle.querySelector('input[type="radio"]:checked');
      var soldOut=!!(selectedInput&&selectedInput.dataset.available==='false');
      var form=main.querySelector('form[id^="product-form-"]');
      var busy=!!(
        (form&&form.dataset.orangeCartBusy==='true')||
        button.classList.contains('loading')||
        button.getAttribute('aria-disabled')==='true'
      );
      stickyButton.disabled=soldOut||busy;
      stickyButton.classList.toggle('is-loading',busy);
      stickyButton.setAttribute('aria-busy',busy?'true':'false');
      var label=button.querySelector('span');
      if(actionSubmit){
        actionSubmit.disabled=soldOut||busy;
        actionSubmit.setAttribute('aria-busy',busy?'true':'false');
        actionSubmit.textContent=soldOut?bar.dataset.orangeStickySoldOut:(busy?(label&&label.textContent.trim()||bar.dataset.orangeStickyOpening):bar.dataset.orangeStickyBuyNow);
      }
      if(label&&label.textContent.trim()) stickyLabel.textContent=label.textContent.trim();

      var pack=selectedPack();
      if(pack){
        var name=pack.querySelector('.orange-pack__copy strong');
        var detail=pack.querySelector('.orange-pack__copy small');
        var current=pack.querySelector('.orange-pack__price strong');
        var compare=pack.querySelector('.orange-pack__price s');
        if(stickyTitle&&name&&name.textContent.trim()){
          stickyTitle.textContent=name.textContent.trim();
        }
        if(stickyVariant){
          stickyVariant.textContent=detail&&detail.textContent.trim()?detail.textContent.trim():'';
        }
        if(current&&current.textContent.trim()) stickyPrice.textContent=current.textContent.trim();
        if(stickyCompare){
          if(compare&&compare.textContent.trim()){
            stickyCompare.textContent=compare.textContent.trim();
            stickyCompare.hidden=false;
          }else{
            stickyCompare.textContent='';
            stickyCompare.hidden=true;
          }
        }
      }
      syncPicker();
    }

    function setOpen(open){
      if(!mainBundle) open=false;
      if(open&&pickerMount){
        actionQty=1;
        renderActionQty();
        lastScrollY=Math.max(0,window.scrollY);
        pickerMount.querySelectorAll('.orange-pack').forEach(function(card){
          card.classList.remove('is-benefits-open');
        });
      }
      bar.classList.toggle('is-open',open);
      stickyButton.setAttribute('aria-expanded',open?'true':'false');
      if(picker) picker.setAttribute('aria-hidden',open?'false':'true');
      if(open) bar.hidden=false;
    }

    // Keep the final content scrollable above the collapsed mobile sticky sheet.
    var mainContent=document.getElementById('MainContent');
    function reserveCollapsedRoom(){
      if(!mainContent||!sheet||bar.classList.contains('is-open')) return;
      var collapsedHeight=Math.ceil(sheet.getBoundingClientRect().height);
      if(collapsedHeight>0){
        mainContent.style.setProperty('--orange-sticky-collapsed-room',(collapsedHeight+28)+'px');
      }
    }
    if(window.ResizeObserver&&sheet){
      new ResizeObserver(reserveCollapsedRoom).observe(sheet);
    }

    // ORANGE PRODUCT STICKY IOS BOTTOM BOUNCE FIX V2
    function mainButtonPassed(){
      var button=mainButton();
      if(!button) return false;
      return button.getBoundingClientRect().bottom<0;
    }

    function distanceFromPageBottom(){
      var doc=document.documentElement;
      var body=document.body;
      var pageHeight=Math.max(
        doc?doc.scrollHeight:0,
        body?body.scrollHeight:0
      );
      var viewportHeight=Math.max(
        window.innerHeight||0,
        window.visualViewport?window.visualViewport.height:0
      );
      return pageHeight-(Math.max(0,window.scrollY)+viewportHeight);
    }

    function atPageBottom(){
      return distanceFromPageBottom()<=140;
    }

    function shouldShowSticky(){
      return mainButtonPassed()&&(direction==='down'||(mobile.matches&&atPageBottom()));
    }

    function position(){
      if(!mainButton()){bar.hidden=true;return}
      if(bar.classList.contains('is-open')){bar.hidden=false;return}
      bar.hidden=!shouldShowSticky();
      reserveCollapsedRoom();
    }

    function updateVisibilityByDirection(){
      var currentY=Math.max(0,window.scrollY);

      if(bar.classList.contains('is-open')){
        lastScrollY=currentY;
        return;
      }

      if(mobile.matches&&mainButtonPassed()&&atPageBottom()){
        direction='down';
        lastScrollY=currentY;
        bar.hidden=false;
        return;
      }

      var delta=currentY-lastScrollY;

      if(delta>3){
        direction='down';
        lastScrollY=currentY;
        bar.hidden=!mainButtonPassed();
        return;
      }

      if(delta<-3){
        direction='up';
        lastScrollY=currentY;
        bar.hidden=true;
      }
    }

    buildPicker();
    syncPicker();

    if(pickerMount){
      pickerMount.addEventListener('change',function(event){
        if(!event.target.matches('input[type="radio"]')||!mainBundle) return;
        pickerMount.querySelectorAll('.orange-pack').forEach(function(card){
          card.classList.remove('is-benefits-open');
        });
        var stickyCard=event.target.closest('.orange-pack');
        if(stickyCard) stickyCard.classList.add('is-benefits-open');
        var target=[].slice.call(mainBundle.querySelectorAll('input[type="radio"]')).find(function(input){
          return input.value===event.target.value;
        });
        if(!target||target.disabled) return;
        target.dataset.orangeStickySync='true';
        target.checked=true;
        var form=main.querySelector('form[id^="product-form-"]');
        var idInput=form&&form.querySelector('input[name="id"]');
        if(idInput&&mainBundle.dataset.mode==='variant'){
          idInput.disabled=false;
          idInput.value=target.value;
        }
        target.dispatchEvent(new Event('change',{bubbles:true}));
        delete target.dataset.orangeStickySync;
        sync();
        window.setTimeout(sync,40);
      });

      pickerMount.addEventListener('click',function(event){
        var card=event.target.closest&&event.target.closest('.orange-pack');
        if(!card||event.target.closest('.orange-pack__benefits')) return;
        if(event.target.matches&&event.target.matches('input[type="radio"]')) return;
        var input=card.querySelector('input[type="radio"]');
        if(!input||input.disabled) return;
        var wasOpen=card.classList.contains('is-benefits-open');
        pickerMount.querySelectorAll('.orange-pack').forEach(function(item){
          item.classList.remove('is-benefits-open');
        });
        if(!wasOpen) card.classList.add('is-benefits-open');
      });
      // ORANGE STICKY SKU BENEFIT TOGGLE V1
      // ORANGE PRODUCT STICKY NO BACKGROUND JUMP V1
    }

    if(actionQtyMinus){
      actionQtyMinus.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        actionQty=Math.max(1,actionQty-1);
        renderActionQty();
      });
    }

    if(actionQtyPlus){
      actionQtyPlus.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        actionQty=Math.min(99,actionQty+1);
        renderActionQty();
      });
    }

    if(actionSubmit){
      // ORANGE PRODUCT STICKY DIRECT CHECKOUT V1
      actionSubmit.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        var button=mainButton();
        if(!button) return;
        var checked=mainBundle&&mainBundle.querySelector('input[type="radio"]:checked');
        if(checked&&checked.dataset.available==='false') return;
        bar.hidden=false;
        applyActionQuantity();
        button.disabled=false;
        button.removeAttribute('aria-disabled');
        button.click();
        window.setTimeout(sync,0);
      });
    }

    renderActionQty();

    // ORANGE PRODUCT STICKY DIRECT CHECKOUT V1
    stickyButton.addEventListener('click',function(event){
      event.preventDefault();
      event.stopPropagation();
      var button=mainButton();
      if(!button) return;
      var checked=mainBundle&&mainBundle.querySelector('input[type="radio"]:checked');
      if(checked&&checked.dataset.available==='false') return;
      bar.hidden=false;
      button.disabled=false;
      button.removeAttribute('aria-disabled');
      button.click();
      window.setTimeout(sync,0);
    });

    if(stickyInner){
      stickyInner.addEventListener('click',function(){
        if(!mainBundle||bar.classList.contains('is-open')) return;
        setOpen(true);
      });
    }

    if(closeButton){
      closeButton.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        direction='up';
        lastScrollY=Math.max(0,window.scrollY);
        bar.hidden=true;
      });
    }

    window.OrangeStickySwipe.bind(bar,function(){
      setOpen(false);
      position();
    });

    document.addEventListener('pointerdown',function(event){
      if(!bar.classList.contains('is-open')) return;
      if(sheet&&sheet.contains(event.target)) return;
      setOpen(false);
      position();
    },true);

    document.addEventListener('keydown',function(event){
      if(event.key==='Escape'&&bar.classList.contains('is-open')){
        setOpen(false);
        position();
        stickyButton.focus();
      }
    });

    mobile.addEventListener('change',function(){
      setOpen(false);
      lastScrollY=Math.max(0,window.scrollY);
      position();
    });

    var scheduled=false;
    window.addEventListener('scroll',function(){
      if(scheduled) return;
      scheduled=true;
      requestAnimationFrame(function(){
        updateVisibilityByDirection();
        scheduled=false;
      });
    },{passive:true});
    window.addEventListener('resize',position,{passive:true});
    if(window.visualViewport){
      window.visualViewport.addEventListener('resize',position,{passive:true});
    }

    main.addEventListener('change',function(){
      window.setTimeout(function(){sync();position()},60);
    });

    var observer=new MutationObserver(function(){sync();position()});
    observer.observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','class','checked','data-orange-cart-busy','aria-disabled']});

    // ORANGE CART DRAWER CHECKOUT CLICK GUARD V1
    var cartDrawer=document.querySelector('cart-drawer');
    if(cartDrawer){
      function syncWithCartDrawer(){
        var drawerOpen=cartDrawer.classList.contains('active');
        if(drawerOpen){
          if(bar.classList.contains('is-open')) setOpen(false);
          bar.hidden=true;
          bar.style.pointerEvents='none';
          return;
        }
        bar.style.removeProperty('pointer-events');
        position();
      }
      var cartObserver=new MutationObserver(syncWithCartDrawer);
      cartObserver.observe(cartDrawer,{attributes:true,attributeFilter:['class']});
      syncWithCartDrawer();
    }

    sync();
    position();
    bar.dataset.orangeStickyReady='true';
  }

  function init(root){(root||document).querySelectorAll('[data-orange-sticky-cart]').forEach(initBar)}

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){init(document)},{once:true});
  }else{
    init(document);
  }
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orange-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(section){
    if(!section||section.dataset.orangeUpsellReady==='true') return;
    var productId=section.dataset.productId;
    var sectionId=section.dataset.sectionId;
    var slot=section.querySelector('[data-orange-upsell-slot]');
    if(!productId||!sectionId||!slot) return;

    section.dataset.orangeUpsellReady='true';
    var url='/recommendations/products?section_id='+encodeURIComponent(sectionId)+'&product_id='+encodeURIComponent(productId)+'&limit=3&intent=related';

    fetch(url)
      .then(function(response){return response.text();})
      .then(function(text){
        var doc=new DOMParser().parseFromString(text,'text/html');
        var template=doc.querySelector('[data-orange-upsell-recommendations]');
        if(!template) return;
        var html=template.innerHTML.trim();
        if(html) slot.innerHTML=html;
      })
      .catch(function(){});
  }

  function initAll(root){
    (root||document).querySelectorAll('[data-orange-upsell]').forEach(init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
